import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {LuClipboardList} from "react-icons/lu";
import {BsChevronLeft, BsShop} from "react-icons/bs";
import {FaCubes} from "react-icons/fa";
import {TbDoorExit, TbReportAnalytics} from "react-icons/tb";

import {useNavigate} from "react-router-dom";
import {GiHamburgerMenu} from "react-icons/gi";
import LogoPic from "../../Assets/Images/logo.png";
import {BiSolidSelectMultiple} from "react-icons/bi";
import {LiaUserEditSolid} from "react-icons/lia";



function ManagerProducts() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [user, setUser] = React.useState([]);
    const [orderCount, setOrderCount] = React.useState([]);
    const [vendor, setVendor] = React.useState([]);
    const [activeProducts, setActiveProduct] = React.useState(0);
    const [inactiveProducts, setInactiveProduct] = React.useState(0);


    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }
        API.getUserInfo()
            .then((response) => {

                  setUser(response.data.user);
                for(let v in response.data.user.vendor) {
                    if(response.data.user.vendor[v].id === parseInt(window.localStorage.getItem("vendor"))) {
                        setOrderCount(response.data.user.vendor[v].ordersCount)
                    }
                }

            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
        const params = {
            processFor: 'Suppliers',
            vendor_id: window.localStorage.getItem("vendor"),
            vendor: window.localStorage.getItem("vendor"),
            orderBy: 'id',
            orderType: 'desc',

        }
        API.getVendor(params)
            .then((response) => {
                setIsLoaded(true);
                setVendor(response.data)
            })
            .catch((error) => {
                setTimeout (() => {
                    navigate(`/vendor/select`)
                },400)
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });


    }, []);


    React.useEffect(() => {

        if (vendor?.products) {
            let activeCount = 0;
            let inactiveCount = 0;

            vendor.products.forEach(product => {
                if (product.is_active > 0) {
                    activeCount++;
                } else {
                    inactiveCount++;
                }
            });


            setActiveProduct(activeCount);
            setInactiveProduct(inactiveCount);
        }
    }, [vendor.products]);


    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }



    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className="container-fluid  rtl">
                <div className="row bg-primary-color py-3 ps-0" id='menu-button'>
                    <div className="col-6 text-end "
                         onClick={() => {
                             window.document.getElementById('side-menu').style.display = 'block';
                         }}
                    >
                        <GiHamburgerMenu className='text-white fw-bold text-big-3'/>

                    </div>
                    <div className="col-6 text-start">
                        <img src={LogoPic} alt="پخش من" className="rounded " width='30'/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 p-5 ">
                        <div className="row " id='side-menu'>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 text-center">
                                                 {
                                            isLoaded && user?.vendor?.map (vendor  => {
                                                if(vendor.id === parseInt(window.localStorage.getItem("vendor")) ) {
                                                    return (
                                                        <img src={vendor.cover_photo} alt="Cover" className='w-100 mt-3 company-cover-photo' />
                                                    )
                                                }
                                                return '';
                                            } )
                                        }
                                        <div className='text-primary-color mb-4 text-small-2 mt-3'>
                                            {user.name}
                                            &nbsp;

                                            {user.surname}
                                            &nbsp;

                                            (
                                            {
                                                window.localStorage.getItem("vendorTitle")
                                            }
                                            )

                                        </div>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/1`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                                    سفارش های تازه ثبت شده
                                        {
                                            orderCount > 0 &&  <span className='badge badge-pill badge-primary bg-danger mx-2 text-small-3 '>
                                                                    {orderCount}
                                                                </span>
                                        }
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/2`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های جاری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/3`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های تمام شده
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         id='active'
                                    >
                                        <FaCubes className='mx-2'/>
                                        مدیریت کالاها
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/manage`)}
                                    >
                                        <BsShop className='mx-2'/>
                                        مدیریت اطلاعات مجموعه
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/select`)}
                                    >
                                        <BiSolidSelectMultiple className='mx-2'/>
                                        انتخاب مجموعه فعال
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/edit-profile`)}
                                    >
                                        <LiaUserEditSolid className='mx-2'/>
                                        ویرایش حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/reports`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش فاکتورهای فروش
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
     <div className="col-12 item "
                                         onClick={() => navigate(`/product-reports`)}

                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش  فروش کالا
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/wallet`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش صورت عملکرد
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={onExitClick}
                                    >
                                        <TbDoorExit className='mx-2'/>
                                        خروج از حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 pt-md-5 pb-5  main-part mt-md-5 main-part mt-md-5">

                        <div className="row px-2 ">
                            <div className="col-12 page-title text-center pb-4 mb-5 border-bottom fw-bold text-muted">
                               مدیریت کالاها
                                <div className='mt-3 text-small-2 fw-normal  rounded p-3'>
                                    تعداد کل :
                                    <span
                                        className='bg-dark px-2 text-white rounded fw-bold mx-2'>{vendor?.products?.length}</span>

                                    |
                                     فعال:
                                    <span className='bg-success px-2 text-white rounded fw-bold mx-2'>
                                    {activeProducts}
                                    </span>
                                    |
                                     غیر فعال:
                                    <span
                                        className='bg-secondary px-2 text-white rounded fw-bold mx-2'>   {inactiveProducts}
                                    </span>
                                </div>
                            </div>


                            <div className="col-6">
                                <button className="btn btn-outline-primary text-small-2"
                                        onClick={() => navigate(`/batch-edit`)}
                                >
                                   ویرایش قیمت کالاها
                                </button>
                            </div>

                            <div className="col-6 text-start">
                               <button className='btn btn-success text-small-2 '
                                       onClick={() => navigate(`/new-product`)}
                               >
                                   افزودن کالای جدید
                               </button>
                            </div>
                            <div className="col-12 mt-4">
                                <table className="table text-small-1  table-striped bg-white order-table">
                                    <thead className='text-small-2'>
                                    <tr className="bg-primary-color text-white text-center small-1 ">
                                        <td>

                                        </td>
                                        <td>
                                            عنوان کالا
                                        </td>
                                        <td>
                                            تعداد فروش
                                        </td>

                                    </tr>
                                    </thead>
                                    <tbody className='text-small-1'>

                                    {
                                        isLoaded && vendor.products.map (product => {

                                            return (
                                                <tr className="text-center" key={product.id}
                                                    onClick={() => navigate(`/product/${product.id}`)}
                                                >
                                                    <td>
                                                       <img src={product.cover_image} alt={product.name} width='70' className='rounded' height='50'/>
                                                    </td>
                                                    <td>
                                                        {product.name}
                                                        {
                                                            product.is_active ? '' :

                                                        <span className=" badge badge-info badge-pill bg-secondary float-start ">
                                                            غیرفعال
                                                        </span>
                                                        }
                                                    </td>
                                                    <td>
                                                        {product.vendor_sale_amount}
                                                    </td>

                                                </tr>
                                            )} )
                                    }

                                    </tbody>
                                </table>

                            </div>

                        </div>

                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default ManagerProducts;